import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import ReactMarkdown from 'react-markdown';
/**
 * MarkdownText - Renders markdown text inline
 *
 * Supports basic markdown syntax:
 * - **bold**
 * - *italic*
 * - [link](url)
 * - `code`
 *
 * @example
 * ```tsx
 * <MarkdownText>This is **bold** and *italic* text</MarkdownText>
 * <MarkdownText>Check out [this link](https://example.com)</MarkdownText>
 * ```
 */
const MarkdownText = ({ children, className, as = 'span' }) => {
    const Container = as;
    return (_jsx(Container, { className: className, children: _jsx(ReactMarkdown, { components: {
                // Override paragraph to render inline instead of block
                p: ({ children }) => _jsx(_Fragment, { children: children }),
                // Keep links styled properly
                a: ({ href, children }) => (_jsx("a", { href: href, target: "_blank", rel: "noopener noreferrer", children: children })),
                // Style code inline
                code: ({ children }) => (_jsx("code", { style: {
                        backgroundColor: '#f4f4f4',
                        padding: '2px 6px',
                        borderRadius: '3px',
                        fontSize: '0.9em'
                    }, children: children })),
            }, children: children }) }));
};
export default MarkdownText;
